import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { ENV } from "@app/env";
import * as $ from "jquery";
import { AppModule } from "./app.module";

window["$"] = $;
window["jQuery"] = $;

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    registerServiceWorker();
  }).catch(err => console.error('Error en el main', err));

function registerServiceWorker() {
  if (ENV.mode !== "Development") {
    if ("serviceWorker" in navigator) {
      window.addEventListener('load', function () {
        navigator.serviceWorker.register('/sw.js').then((reg) => {
          if (!navigator.serviceWorker.controller) {
            return;
          }
          if (!navigator.serviceWorker.controller) {
            return;
          }

          if (reg.waiting) {
            console.info('SW waiting 1');
            updateReady(reg.waiting);
            return;
          }
        }).catch(function (err) {
          console.log("ServiceWorker reg failed: ", err);
        });
        return;
      });
    }
  }
}

function updateReady(worker) {
  if (worker.state === "installed") {
    console.log("New version Available 4");
    showToast();
    sendSkipWaiting(worker);
  }
  worker.addEventListener("statechange", () => {
    // console.log("Escuchando cambios");
    switch (worker.state) {
      case "installed":
        console.log("New version Available 5");
        showToast();
        window["updateAvailabl"] = true;
        console.warn("Check Variable");
        sendSkipWaiting(worker);
    }
  });
}

function showToast() {
  document.body.innerHTML += `<div id="snackbar">
  <div class="symbol">⚠</div>
  New Version Available
  <br> Press <span class="here">here</span> to download it
  </div>`;
  const x = document.getElementById("snackbar");
  x.className = "snackbar show";
}

function sendSkipWaiting(worker) {
  const x = document.getElementById("snackbar");
  x.addEventListener("click", () => {
    worker.postMessage({ action: "skipWaiting" });
    window.location.reload(true);
  });
}




// WEBPACK FOOTER //
// ./src/app/main.ts